/* eslint-disable */

const LOCAL_KEYS = {
  country: 'country_list',
  cell: 'cell_list',
};

const localStore = (key, data) => {
  if (data !== undefined) {
    localStorage.setItem(key, JSON.stringify(data));
  }

  const stored = localStorage.getItem(key);
  return stored ? JSON.parse(stored) : null;
};

export const countryStore = (data) => localStore(LOCAL_KEYS.country, data);
export const cellStore = (data) => localStore(LOCAL_KEYS.cell, data);
